export default "__VITE_ASSET__9611f190__"